import { JobApplicationStep } from "../types/JobApplicationStep";
import { JobApplicationStepKey } from "../types/JobApplicationStepKey";

export const mapJobApplicationStepKey: Record<JobApplicationStepKey, number> = {
  CANDIDATE: JobApplicationStep.CANDIDATE,
  DETAILS: JobApplicationStep.DETAILS,
  FILES: JobApplicationStep.FILES,
  QUESTIONNAIRE: JobApplicationStep.QUESTIONNAIRE,
  WORKSTYLES: JobApplicationStep.WORKSTYLES,
  SUMMARY: JobApplicationStep.SUMMARY,
};
